import Vue from 'vue'
import Vuex from 'vuex'
import utils from '@/utils.js'
// import gql from '@/gqlService.coffee'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        authenticated: false,
        profile: null,
        selected_review_uid: null,
        selected_consultant_uid: null,
        notification: null,
        selected_establishment_uid: null,
        show_menu_text: utils.fromStorage("show_menu_text") === "true",
        models: null,
        edited_fields: {},
        notifications: [],
        tag_name: {},
        selected_assistant_uid: null,
        stats: null
    },

    mutations: {
        select_assistant(state, assistant_uid) {
            state.selected_assistant_uid = assistant_uid
        },
        unselect_assistant(state) {
            state.selected_assistant_uid = null
        },
        set_tag_name(state, val) {
            state.tag_name = val
        },
        unselect_review(state) {
            state.selected_review_uid = null
        },
        select_review(state, uid) {
            state.selected_review_uid = uid
        },
        select_consultant(state, uid) {
            state.selected_consultant_uid = uid
        },
        select_establishment(state, uid) {
            state.selected_establishment_uid = uid
        },
        authenticate(state) {
            state.authenticated = true
        },
        set_profile(state, new_profile) {
            state.profile = new_profile
        },
        set_notification(state, notification) {
            state.notification = notification
        },
        remove_notification(state) {
            state.notification = null
        },
        toggle_menu_text(state) {
            state.show_menu_text = !state.show_menu_text
            utils.toStorage("show_menu_text", state.show_menu_text)
        },
        set_models(state, models) {
            state.models = models
        },
        update_edited_fields(state, args) {
            state.edited_fields[args.key] = args
        },
        delete_edited_fields(state, args) {
            delete state.edited_fields[args.key]
        },
        set_stats(state, stats) {
            state.stats = stats
        }
    },

    actions: {
        set_schema(context, raw_schema) {
            const models = {}
            for (let t of raw_schema.types) {
                const match = "Type"
                if (t.name.slice(-match.length) === match) {
                    models[t.name] = t
                    const fields_map = {}
                    for (let f of t.fields) {
                        fields_map[f.name] = f
                    }
                    models[t.name]["fields_map"] = fields_map
                }
            }
            context.commit("set_models", models)
        },

        notify(context, notification) {
            context.commit("set_notification", notification)
            if (notification.seconds !== undefined && notification.seconds !== null) {
                const ctx = context
                console.log("notification", notification)
                setTimeout(() => {
                    ctx.commit("set_notification", null)
                }, notification.seconds * 1000)
            }
        },

        set_authenticated(context, profile) {
            context.commit("authenticate")
            context.commit("set_profile", profile)
        },

        select_review(context, review_uid) {
            context.commit("unselect_review")
            context.commit("select_review", review_uid)
        },

        select_assistant(context, assistant_uid) {
            context.commit("unselect_assistant")
            context.commit("select_assistant", assistant_uid)
        }
    }
})
